import { postData } from "../api/fetch";
import initCardSwiper from "../components/cardSwiper";
import initModals from "../components/initModal";
import { getCatalog, getCountry, numberRu } from "./getCatalog";

export function getAuto(act) {
  // window.action_card = act;

  // const params = new URLSearchParams(window.location.search);
  // const car_id = Number(params.get("id"));
  // const inputEl = document.querySelector('[name="car_id"]');
  // if (inputEl) {
  //   inputEl.value = String(car_id);
  // }

  // const data = {
  //   act,
  //   id: inputEl.value,
  // };

  // getPostData(data);

  getCard();
  initModals();
}

function getPostData(data) {
  postData(window.api_url, data)
    // postData('/api', data)
    .then((response) => {
      if (response.length !== 0) {
        if (Number(response[0].carid) === 0) {
          getError();
        } else {
          const avtoCardWrapperEl =
            document.querySelector(".avtoCard__wrapper");
          if (avtoCardWrapperEl) {
            avtoCardWrapperEl.style.display = "";
            const catalogueWrapperEl = document.querySelector(
              ".avtocCard__wrapper2",
            );
            if (catalogueWrapperEl) {
              catalogueWrapperEl.remove();
            }
          }

          const aboutEl = document.getElementById('about');
          if (aboutEl) aboutEl.style.display = "";
          getCard(response[0]);
        }
        initModals();
      } else {
        getError();
      }
    })
    .catch((err) => {
      console.error("Ошибка при POST запросе:", err);
    });
}

function getError() {
  const catalogueWrapperEl = document.querySelector(".avtocCard__wrapper2");
  const errorEl = document.createElement("span");
  errorEl.className = "our-card__title";
  errorEl.textContent = "По вашему запросу авто не найдено!";
  catalogueWrapperEl.prepend(errorEl);

  if (catalogueWrapperEl) {
    catalogueWrapperEl.style.display = "";
    const avtoCardWrapperEl = document.querySelector(".avtoCard__wrapper");
    if (avtoCardWrapperEl) {
      avtoCardWrapperEl.remove();
    }
  }

  const aboutEl = document.getElementById('about');
  if (aboutEl) aboutEl.remove();

  getCatalog();
}

function getCard(car = null) {
  // // Марка и модель
  // const makeEl = document.getElementById("make");
  // if (makeEl) {
  //   makeEl.innerHTML = `${car.make} ${car.model}`;
  // }

  // // Страна
  // const countryEl = document.getElementById("country");
  // if (countryEl) {
  //   countryEl.textContent = getCountry(car.country);
  // }

  // // Год выпуска
  // const yearEl = document.getElementById("year");
  // if (yearEl && car.year) {
  //   yearEl.textContent = `${car.year !== 0 || car.year !== null ? car.year : "н/д"}`;
  // }

  // // Тип двигателя
  // const whatfuelEl = document.getElementById("whatfuel");
  // if (whatfuelEl) {
  //   whatfuelEl.textContent = `${car.whatfuel !== "" && car.whatfuel !== null ? car.whatfuel : "н/д"}`;
  // }

  // // Объем двигателя, см³
  // const engineEl = document.getElementById("engine");
  // if (engineEl) {
  //   engineEl.textContent = `${car.engine !== 0 && car.engine !== null ? car.engine : "н/д"}`;
  // }

  // // Мощность
  // const powerEl = document.getElementById("power");
  // if (powerEl) {
  //   powerEl.textContent = `${car.power !== 0 && car.power !== null ? car.power : "н/д"}`;
  // }

  // // Трансмиссия

  // // Пробег, км
  // const mileageEl = document.getElementById("mileage");
  // if (mileageEl) {
  //   mileageEl.innerHTML = `${car.mileage !== 0 && car.mileage !== null ? numberRu(car.mileage) : "н/д"}`;
  // }

  // // Комплектация
  // const complectationEl = document.getElementById("complectation");
  // if (complectationEl) {
  //   complectationEl.innerHTML = `${car.complectation !== 0 && car.complectation !== null ? car.complectation : "н/д"}`;
  // }

  // // Наличие
  // // Итоговая стоимость
  // const priceEl = document.getElementById("price");
  // if (priceEl) {
  //   priceEl.innerHTML = `${numberRu(car.price)} ₽`;
  // }

  // const avtoCardBtnEls = document.querySelectorAll(
  //   '[aria-name="avtoCard-btn"]',
  // );
  // if (avtoCardBtnEls.length !== 0) {
  //   avtoCardBtnEls.forEach((btn) => {
  //     // btn.setAttribute("car_id", `${car.carid}`);
  //     btn.setAttribute("car_id", `${car.id}`);
  //   });
  // }

  // car.images.forEach((image) => {
  //   const swiperWrapperEls = document.querySelectorAll(".swiper-wrapper");

  //   swiperWrapperEls.forEach((swiperEl) => {
  //     const slide = document.createElement("div");
  //     slide.className = "swiper-slide";
  //     slide.innerHTML = `
  //     <img
  //       class="avtoCard__img"
  //       src="https://cx09748.tw1.ru/${image}"
  //       alt="Фото авто"
  //       loading="lazy"
  //     >
  //   `;
  //     //   slide.innerHTML = `
  //     //   <img
  //     //     class="avtoCard__img"
  //     //     src="https://spbkar.ru/${image}"
  //     //     alt="Фото авто"
  //     //     loading="lazy"
  //     //   >
  //     // `;
  //     swiperEl.append(slide);
  //   });
  // });

  initCardSwiper();

  const btnSubmitEl = document.getElementById("btn-submit");
  if (btnSubmitEl) {
    btnSubmitEl.addEventListener("click", (e) => {
      const btnModalEl = document.getElementById("modal-submit");
      if (!btnModalEl) return;

      btnModalEl.setAttribute("car_id", `${e.target.getAttribute("car_id")}`);

      if (window.action_card === "get_auto_card") {
        btnModalEl.setAttribute("going", "0");
      } else if (window.action_card === "get_auto_cardmy") {
        btnModalEl.setAttribute("going", "1");
      }
    });
  }

  const btnWriteEl = document.getElementById("btn-write");
  if (btnWriteEl) {
    btnWriteEl.addEventListener("click", (e) => {
      const btnModalEl = document.getElementById("modal-submit");
      if (!btnModalEl) return;

      btnModalEl.setAttribute("car_id", `${e.target.getAttribute("car_id")}`);

      if (window.action_card === "get_auto_card") {
        btnModalEl.setAttribute("going", "0");
      } else if (window.action_card === "get_auto_cardmy") {
        btnModalEl.setAttribute("going", "1");
      }
    });
  }
}
